/* eslint-disable import/prefer-default-export */
import { createUseQueryHook, QueryLike, UseQueryHookOptions } from 'mst-gql';
import * as React from 'react';
import getAppRoot from './getAppRoot';
import { StoreContext } from './mstProvider';
import { IApp } from '../App';

const baseUseQuery = createUseQueryHook(StoreContext, React);

export const useQuery = <Data>(query?: QueryLike<IApp['model'], Data>, opts?: UseQueryHookOptions<IApp['model']>) => {
  const self = baseUseQuery(query, opts);

  const store = React.useContext(StoreContext);

  return {
    ...self,
    store: getAppRoot(store),
  };
};

export const useStore = () => {
  const store = React.useContext(StoreContext);
  return getAppRoot(store);
};
